import React from "react";
import { NavLink } from "react-router-dom";
import "./AdminQuickLinks.css";

const links = [
  {
    path: "/admin-addtennis",
    icon: "🎾",
    label: "Add Tennis",
  },
  {
    path: "/adminadd-tabletennes",
    icon: "🏓",
    label: "Add Table Tennis",
  },
  {
    path: "/adminadd-basketball",
    icon: "🏀",
    label: "Add Basketball",
  },
  {
    path: "/adminadd-icehockey",
    icon: "⛸️",
    label: "AddIceHockey",
  },

  {
    path: "/adminadd-baseball",
    icon: "⚾🧢",
    label: "BaseBall",
  },
 
];

export default function AdminQuickLinks() {
  return (
    <nav className="admin-quick-links">
      {links.map((link) => (
        <NavLink
          key={link.path}
          to={link.path}
          className={({ isActive }) =>
            `admin-quick-link ${isActive ? "active" : ""}`
          }
        >
          <span className="admin-quick-icon">{link.icon}</span>
          <span>{link.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}